import { Badge } from "@/components/ui/badge";

export const QUOTE_STATUS = {
  brouillon: { label: "Brouillon", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  envoye: { label: "Envoyé", cls: "bg-cyan-500/10 text-cyan-700 border-cyan-500/30" },
  accepte: { label: "Accepté", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  refuse: { label: "Refusé", cls: "bg-red-500/10 text-red-700 border-red-500/30" },
  expire: { label: "Expiré", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
};

export const INVOICE_STATUS = {
  brouillon: { label: "Brouillon", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  envoyee: { label: "Envoyée", cls: "bg-cyan-500/10 text-cyan-700 border-cyan-500/30" },
  partiellement_payee: { label: "Partiellement payée", cls: "bg-amber-500/10 text-amber-700 border-amber-500/30" },
  payee: { label: "Payée", cls: "bg-emerald-500/10 text-emerald-700 border-emerald-500/30" },
  en_retard: { label: "En retard", cls: "bg-red-500/10 text-red-700 border-red-500/30" },
  annulee: { label: "Annulée", cls: "bg-slate-100 text-slate-500 border-slate-300" },
};

export function DocStatusBadge({ status, map }) {
  const s = map[status] || { label: status, cls: "bg-slate-100 text-slate-600 border-slate-300" };
  return <Badge variant="outline" className={`font-medium ${s.cls}`} data-testid={`docstatus-${status}`}>{s.label}</Badge>;
}
